// Shared prospect label helpers (stage, follow-up, phone-suggestion source) so
// the copy reads identically everywhere a coach (or the queue) sees it.

const STAGE_LABELS = {
  inquiry: 'Interested',
  trial_scheduled: 'Trial Scheduled',
  trialing: 'Trialing',
  trial_complete: 'Trial Complete',
  converted: 'Converted',
  didnt_join: "Didn't Join",
  archived: 'Archived',
};

const FOLLOW_UP_REASON_LABELS = {
  inquiry: 'New inquiry',
  trial_complete: 'Trial complete',
  stage_change: 'Flagged',
  manual: 'Flagged',
  stale_contact: 'No contact in a week',
  needs_scheduling: 'Needs scheduling',
};

export function stageLabel(stage) {
  return STAGE_LABELS[stage] || stage;
}

// A trial that's been purchased but has no date yet reads as "Needs Scheduling"
// rather than the (inaccurate) "Trial Scheduled". This is a display-only
// sub-state of the trial_scheduled stage — not a separate pipeline stage.
export function childStageLabel(child) {
  if (!child) return '';
  if (child.stage === 'trial_scheduled' && !child.trial_scheduled_at) {
    return 'Needs Scheduling';
  }
  return stageLabel(child.stage);
}

export function followUpReasonLabel(reason) {
  return FOLLOW_UP_REASON_LABELS[reason] || '';
}

// Where a suggested phone number came from, e.g. "Parent 2 › Phone number".
// The form-builder section name matters: a bare "Phone number" prompt doesn't
// say whose number it is. Skip the section when the prompt already names it
// ("Parent 2 cell").
export function suggestionPromptLabel(suggestion) {
  const prompt = suggestion.question_prompt || '';
  const group = suggestion.question_group;
  if (!group || prompt.toLowerCase().includes(group.toLowerCase())) return prompt;
  return `${group} › ${prompt}`;
}
